// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__c841c4b5d2b47bf104e1","cls2":"AccountMenu-cls2___ac8ff77b7ff3c4ffb3d AccountMenu-cls1__c841c4b5d2b47bf104e1"};